import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initRedditPixel, trackRedditEvent } from '@/utils/redditPixel';

/**
 * Initializes Reddit Pixel on mount and tracks PageVisit on route changes.
 * Also fires ViewContent on each page navigation.
 */
export function RedditPixelInit() {
  const location = useLocation();

  // Initialize pixel once on mount
  useEffect(() => {
    initRedditPixel();
  }, []);

  // Track PageVisit + ViewContent on route change
  useEffect(() => {
    trackRedditEvent('PageVisit');
    trackRedditEvent('ViewContent');
  }, [location.pathname]);

  return null;
}
